import { shopCLient } from '@/services/axiosConfig'

export type RateProduct = (id: number, point: string) => Promise<string>

export const rateProduct: RateProduct = async (id, point) => {
  try {
    const response = await shopCLient.post(`/product/rating?productId=${id}`, { point })
    return response.data
  } catch (e) {
    console.error('categories fetch failed e')
  }
}
